import RightRobotCard from './common/RightRobotCard'
import useWindowSize from 'components/util/useWindowSize'
import { siliconRoundaboutStrings } from 'common/strings/silicon-roundabout-strings'

const EastLondonTechCityCard = () => {
  const size = useWindowSize()
  return (
    <RightRobotCard
      className='key-benefits-card'
      imageContainerWidth={size.isLgOrHigher ? '40%' : '100%'}
      image={{
        alt: 'Robot arm right cropped for tech city',
        desktop: {
          dimensions: {
            height: 760,
            width: 507,
          },
          src: '/images/new/robot-arm-right-croped.png',
        },
        mobile: {
          dimensions: {
            height: 897,
            width: 550,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      reverseColumnOrder={!size.isLgOrHigher}
      imageStyle={{
        height: '100%',
        maxWidth: '100%',
        objectFit: 'cover',
        objectPosition: 'left',
      }}
    >
      <div className='d-flex flex-1 flex-column mt-n26 mt-lg-0 px-4 pe-lg-0 pt-8 ps-lg-20 pt-16 pb-8 pb-lg-30 fw-semibold'>
        <h2 className='fs-fluid-36-80 lh-105 fw-semibold mb-5 mb-lg-3'>
          East London Tech City
        </h2>
        <div
          className='fs-fluid-18-28 lh-132 lh-lg-114 text-grey9'
          dangerouslySetInnerHTML={{
            __html: `${siliconRoundaboutStrings.eastLondonTechCityContent}`,
          }}
        />
      </div>
    </RightRobotCard>
  )
}

export default EastLondonTechCityCard
